import { render, staticRenderFns } from "./PetOwnerForgetPassword.vue?vue&type=template&id=7886934c&scoped=true&"
import script from "./PetOwnerForgetPassword.vue?vue&type=script&lang=js&"
export * from "./PetOwnerForgetPassword.vue?vue&type=script&lang=js&"
import style0 from "./PetOwnerForgetPassword.vue?vue&type=style&index=0&id=7886934c&prod&lang=scss&scoped=true&"
import style1 from "./PetOwnerForgetPassword.vue?vue&type=style&index=1&id=7886934c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7886934c",
  null
  
)

export default component.exports